var runtime = require("../../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"container":"_1U2o1"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._1U2o1{display:grid;display:-ms-grid}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

